import React, { useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import { GET_BLOGS } from "../graphql/queries";
import { ROUTES } from "../routes/routes";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function BlogList({ input }) {
    const { loading, error, data } = useQuery(GET_BLOGS);
    const containerRef = useRef(null);

    useEffect(() => {
        if (data) {
            gsap.fromTo(
                containerRef.current,
                { opacity: 0, y: 20 },
                {
                    opacity: 1,
                    y: 0,
                    scrollTrigger: {
                        trigger: containerRef.current,
                        start: "top 80%",
                        end: "bottom 60%",
                        toggleActions: "play none none none",
                    },
                    duration: 1,
                }
            );
        }
    }, [data]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const filteredData = data.blogs.filter((el) => {
        if (!input) {
            return el;
        } else {
            return el.title.toLowerCase().includes(input.toLowerCase());
        }
    });

    return (
        <div className="post-container" ref={containerRef}>
            {filteredData.map((post) => (
                <Link
                    to={`${ROUTES.blog.path}/${post.slug}`}
                    key={`blog-${post.slug}`}
                >
                    <div key={post.id} className="card">
                        <img src={post.image.url} alt={post.title} />
                        <div className="card-content">
                            <h2>{post.title}</h2>
                            <p className="card-description">
                                {post.description}
                            </p>
                            <p className="card-date">{post.date}</p>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    );
}
